const baseClass = 'select-input';
const focusClass = `${baseClass}--focused`;
const notEmptyClass = `${baseClass}--not-empty`;
const checkedClass = `${baseClass}--checked`;

const selects = [].slice.call(document.querySelectorAll(`.${baseClass}`), 0);

for (let select of selects) {
	const selectElement = select.querySelector('select');
	const inputElement = select.querySelector('input');

	if (!selectElement) {
		continue;
	}

	checkIfEmpty(select, selectElement, inputElement);

	selectElement.addEventListener('focus', e => {
		checkIfEmpty(select, selectElement, inputElement);
		select.classList.add(focusClass);
	});

	selectElement.addEventListener('blur', e => {
		checkIfEmpty(select, selectElement, inputElement);
		select.classList.remove(focusClass);
	});

	selectElement.addEventListener('change', e => {
		checkIfEmpty(select, selectElement, inputElement);
	});
}

function checkIfEmpty(select, selectElement, inputElement) {
	const option = selectElement.options[selectElement.selectedIndex];
	
	if (option) {
		inputElement.value = option.text || option.value;
	}

	if (selectElement.value != '') {
		select.classList.add(notEmptyClass);
	}
	else {
		select.classList.remove(notEmptyClass);
	}
}